import clsx from 'clsx';
import type { HTMLAttributes, ForwardRefRenderFunction } from 'react';
import { forwardRef } from 'react';

interface SidebarContentProps extends HTMLAttributes<HTMLDivElement> {
	children?: React.ReactNode;
	className?: string;
}

const SidebarContent: ForwardRefRenderFunction<
	HTMLDivElement,
	SidebarContentProps
> = ({ children, className, ...rest }, ref) => {
	return (
		<div
			ref={ref}
			className={clsx('sideNav-content scrollbar-sm', className)}
			{...rest}
		>
			{children}
		</div>
	);
};

export default forwardRef(SidebarContent);
